import usePhoto from '../hooks/usePhoto'

import Spinner from '@components/Spinner'
import photoPlaceholder from '../assets/photo-upload.png'

interface PhotoProps {
  onClick?: () => void
}
export default function Photo({ onClick }: PhotoProps) {
  const { photo, isLoading } = usePhoto()

  if (isLoading) {
    return (
      <div className='flex h-50 my-2.5 flex-row items-center justify-center'>
        <Spinner />
      </div>
    )
  }

  if (photo) {
    return (
      <>
        <img
          src={photo}
          onClick={onClick}
          className='object-cover w-40 h-40 mx-auto rounded-full shadow-xl cursor-pointer hover:opacity-75 active:opacity-75 transition-opacity shadow-neutral-400 shadow'
        />
      </>
    )
  }

  return (
    <>
      <img src={photoPlaceholder} onClick={onClick} className='object-cover w-32 mx-auto cursor-pointer' />
    </>
  )
}
